import $ from "jquery";
import L from "leaflet";
require("leaflet-providers");
function trimString(s) {
    var l = 0, r = s.length - 1;
    while (l < s.length && s[l] == ' ')
        l++;
    while (r > l && s[r] == ' ')
        r -= 1;
    return s.substring(l, r + 1);
}
function compareObjects(o1, o2) {
    var k = '';
    for (k in o1)
        if (o1[k] != o2[k])
            return false;
    for (k in o2)
        if (o1[k] != o2[k])
            return false;
    return true;
}
function itemExists(haystack, needle) {
    for (var i = 0; i < haystack.length; i++)
        if (compareObjects(haystack[i], needle))
            return true;
    return false;
}
function searchFor(toSearch, objects) {
    var results = [];
    // toSearch = trimString(toSearch); // trim it
    // console.log(objects);
    for (var i = 0; i < objects.length; i++) {
        for (var key in objects[i]) {
            if (objects[i][key].indexOf(toSearch) != -1) {
                if (!itemExists(results, objects[i]))
                    results.push(objects[i]);
            }
        }
    }
    return results;
}
$(document).ready(function () {
    if ($("#map-lf").length) {
        var map_1 = L.map('map-lf', {
            zoomControl: false,
            minZoom: 8,
            maxZoom: 12
        });
        L.tileLayer.provider('Esri.WorldGrayCanvas').addTo(map_1);
        // map.eachLayer(function(layer) {
        //     map.removeLayer(layer);
        // });
        // map.touchZoom.disable();
        map_1.scrollWheelZoom.disable();
        map_1.on('click', function () {
            if (map_1.scrollWheelZoom.enabled()) {
                map_1.scrollWheelZoom.disable();
            }
            else {
                map_1.scrollWheelZoom.enable();
            }
        });
        var lat = 50.638589;
        var lng = 4.417500;
        // if ($(window).width() > 520) {
        map_1.setView([50.85045, 4.34878], 7);
        // } else {
        //     map.setView([50.6,5.1], 8);
        // }
        // let mapBounds = L.latLngBounds(L.latLng(53.531819,-7.768084), L.latLng(41.002288,11.651138));
        // let mapBounds = L.latLngBounds(L.latLng(51.848674,0.224355), L.latLng(48.868148,9.652971));
        // map.setMaxBounds(mapBounds);
        // let belgiumBounds = L.latLngBounds(L.latLng(49.496407,6.383176), L.latLng(51.511905,2.534811));
        // map.on('drag', function() {
        //     map.panInsideBounds(mapBounds, { animate: false });
        // });
        // let franceBounds = L.latLngBounds(L.latLng(51.417709,-5.304834), L.latLng(41.214614,9.889973));
        // var overlay = new L.ImageOverlay("/app/themes/lumber/static/gfx/france-map.png", franceBounds);
        // map.addLayer(overlay);
        // var overlay = new L.ImageOverlay("/app/themes/lumber/static/gfx/map/belgium-map.svg", belgiumBounds);
        // map.addLayer(overlay);
        L.control.zoom({
            position: ($(window).width() < 600) ? 'topleft' : 'topright'
        }).addTo(map_1);
        //
        var icon_1 = new L.Icon({
            iconUrl: '/app/themes/lumber/static/gfx/pointer.svg',
            iconSize: [30, 30],
            iconAnchor: [15, 30],
            popupAnchor: [1, -30],
            shadowSize: [0, 0]
        });
        var dataPartners_1 = [];
        var pos_1 = {};
        $('.quick-menu-item').map(function (key, item) { pos_1[$(item).attr("data-id")] = []; });
        var addresses_1 = {};
        var mapMarkers_1 = [];
        $.getJSON("/api/pos", function (data) {
            dataPartners_1 = data;
            var length = data.length;
            $.each(data, function (key, val) {
                // console.log(key);
                var location = L
                    .marker([val.latitude, val.longitude], { icon: icon_1 })
                    .bindPopup("\n                    <div class=\"content\">\n                        <h2>" + val.title + "</h2>\n                        <p>" + val.address + "</p>\n                    </div>\n                ")
                    // .openPopup()
                    .addTo(map_1);
                $.each(val.type, function (k, v) {
                    pos_1[v].push({ address: val.address, pointer: location });
                });
                mapMarkers_1.push(location);
                if (key + 1 == length) {
                    // console.log(searchFor(7000, pos));
                }
            });
        });
        function displayPos() {
            var value = $("#searchbox").val();
            var action = value != "" ? "/api/pos/" + value : "/api/pos";
            pos_1 = {};
            $('.quick-menu-item').map(function (key, item) { pos_1[$(item).attr("data-id")] = []; });
            addresses_1 = {};
            for (var i = 0; i < mapMarkers_1.length; i++) {
                map_1.removeLayer(mapMarkers_1[i]);
            }
            mapMarkers_1 = [];
            $.getJSON(action, function (data) {
                dataPartners_1 = data;
                var length = data.length;
                $.each(data, function (key, val) {
                    // console.log(key);
                    var location = L
                        .marker([val.latitude, val.longitude], { icon: icon_1 })
                        .bindPopup("\n                        <div class=\"content\">\n                            <h2>" + val.title + "</h2>\n                            <p>" + val.address + "</p>\n                        </div>\n                    ")
                        // .openPopup()
                        .addTo(map_1);
                    if (pos_1[val.type] !== void 0) {
                        pos_1[val.type].push({ address: val.address, pointer: location });
                    }
                    mapMarkers_1.push(location);
                    if (key + 1 == length) {
                        // console.log(searchFor(7000, pos));
                    }
                });
            });
        }
        $("#search-form").on("click", "button", function (e) {
            e.preventDefault();
            displayPos();
        });
        $("#search-form").on("blur", "#searchbox", function (e) {
            e.preventDefault();
            displayPos();
        });
        var timeOut_1;
        $("#search-form").on("keyup", "#searchbox", function (e) {
            e.preventDefault();
            clearTimeout(timeOut_1);
            timeOut_1 = setTimeout(function () {
                displayPos();
            }, 500);
        });
        $("#quick-menu").on("click", "a:not(.nope)", function (e) {
            e.preventDefault();
            var isCurrent = ($(e.currentTarget).hasClass("selected"));
            $("#quick-menu a.selected").removeClass("selected");
            if (!isCurrent) {
                $(e.currentTarget).addClass("selected");
                var id = $(e.currentTarget).attr("href").replace("#", "");
                // $("#list").find("ul").children("li[data-type='"+ id +"']").fadeIn(300);
                // $("#list").find("ul").children("li:not([data-type='"+ id +"'])").fadeOut(300);
                for (var i = 0; i < mapMarkers_1.length; i++) {
                    map_1.removeLayer(mapMarkers_1[i]);
                }
                if (pos_1[id] !== void 0) {
                    $.each(pos_1[id], function (k, v) {
                        v.pointer.addTo(map_1);
                        mapMarkers_1.push(v.pointer);
                    });
                }
            }
            else {
                // $("#list").find("ul").children("li").fadeIn(300);
                $.each(pos_1, function (key, obj) {
                    $.each(obj, function (k, v) {
                        v.pointer.addTo(map_1);
                        mapMarkers_1.push(v.pointer);
                    });
                });
            }
        });
    }
});
